import { PageRouteBuilder } from "@common/route/page-route-builder";
import { DeleteUserPageComponent } from "./delete-user-page.component";

export const deleteUserPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-delete-user-page", DeleteUserPageComponent)
    .requiresLogin()
    .atUrl("/tools/delete-user")
    .withTitle("Delete User")
    .build();
